"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/web.dom.iterable");
var _date = require("@/utils/date");
var _util = require("@/utils/util");
var _demurrage = require("@/api/query/demurrage");
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'demurrageCalculation',
  data: function data() {
    var _this = this;
    var validateBlCTNo = function validateBlCTNo(rule, value, callback) {
      if ((0, _validate.validateNull)(_this.form.blNo) && (0, _validate.validateNull)(_this.form.containerNo)) {
        callback(new Error(_this.$t('demurrageCalculation.blCtNoNotNull')));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.pickerOneDate !== '') {
            var curDate = new Date().getTime();
            var three = 91 * 24 * 3600 * 1000;
            var threeMonths = curDate + three;
            return time.getTime() < Date.now() - 24 * 3600 * 1000 || time.getTime() > threeMonths;
          }
          return false;
        }
      },
      loading: null,
      form: {
        blNo: '',
        containerNo: '',
        calculationDate: ''
      },
      showResult: false,
      demDetFeeData: [],
      rules: {
        blNo: [{
          validator: validateBlCTNo,
          trigger: 'blur'
        }],
        containerNo: [{
          validator: validateBlCTNo,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    dateFormat: _date.dateFormat,
    toMoney: _util.toMoney,
    validateNull: _validate.validateNull,
    /**
     * 查询
     * */
    toSearch: function toSearch() {
      var _this2 = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this2.showResult = false;
          _this2.demDetFeeData = [];
          _this2.loading = (0, _utils.load)();
          (0, _demurrage.demDetCalculation)(_this2.form).then(function (response) {
            if (!_this2.validateNull(response.data)) {
              if (Array.isArray(response.data)) {
                _this2.showResult = true;
                _this2.demDetFeeData = response.data;
              } else {
                _this2.showResult = true;
                _this2.demDetFeeData = [response.data];
              }
            } else {}
          }).catch(function () {
            _this2.demDetFeeData = [];
            _this2.showResult = false;
          }).finally(function () {
            _this2.loading.close();
          });
        }
      });
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      var currentDate = new Date((0, _date.dateFormat)('YYYY-MM-DD', new Date()));
      var endDate = new Date((0, _date.dateFormat)('YYYY-MM-DD', row.endMoveDate));
      if (currentDate === endDate) {
        return 'blue-row';
      } else if (row.calculateType === 0) {
        return '';
      } else {
        return 'warning-row';
      }
    },
    /**
     *  DEM 合计
     **/
    getDemDetSummaries: function getDemDetSummaries(param) {
      var _this3 = this;
      var columns = param.columns,
        data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 11) {
          sums[index] = _this3.$t('equipmentFee.total');
          return;
        }
        if (index === 12) {
          var values = data.map(function (item) {
            return _this3.moneyToNumFiled(item[column.property]) + item.amountTax;
          });
          sums[index] = (0, _util.toMoney)(values.reduce(function (accumulator, pilot) {
            return accumulator + pilot;
          }, 0));
          return;
        }
        if (index === 13) {
          var _values = data.map(function (item) {
            return item[column.property];
          });
          sums[index] = _values[0];
        }
      });
      return sums;
    },
    moneyToNumFiled: function moneyToNumFiled(obj) {
      var ss = obj.toString();
      if (ss.length === 0) {
        return '';
      }
      return isNaN(Number(ss.replace(/,/g, ''))) ? 0 : Number(ss.replace(/,/g, ''));
    }
  }
};